import React from 'react';
import i18next from '../../../i18next';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import { statusRenderer } from '../onboardingUtils';

interface IViewUserDetailsProps {
  panelSelectedRow: any;
}
export const ViewUserDetails = (props: IViewUserDetailsProps) => {
  const objectToArray = (obj: any) => {
    const keysArr = Object.keys(obj);
    return keysArr.map(key => {
      return {
        listKey: key,
        listValue: obj[key]
      };
    });
  };
  return (
    <React.Fragment>
      {props.panelSelectedRow
        ? objectToArray(props.panelSelectedRow)
            .filter(
              listElData =>
                listElData.listKey === 'firstName' ||
                listElData.listKey === 'lastName' ||
                listElData.listKey === 'email' ||
                listElData.listKey === 'phone' ||
                listElData.listKey === 'status' ||
                listElData.listKey === 'role'
            )
            .map(listElData => {
              return (
                <SplitPanelUtil.PanelListItem
                  key={listElData.listKey}
                  name={i18next.t(listElData.listKey)}
                  valueRenderer={() => (
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      {statusRenderer(listElData.listValue)}
                      <div>{listElData.listValue}</div>
                    </span>
                  )}
                />
              );
            })
        : null}
    </React.Fragment>
  );
};
